import { config } from '../../config';
import { ContactRepMethod } from '../../types';
import { client } from '../http';

export interface ContactRepMethodData {
  customer_id: string;
  order_id: string;
  brand_id: string;
  option: ContactRepMethod;
  project_id: string;
}

export const saveContactRepMethod = async (
  contactRepMethodData: ContactRepMethodData,
) => {
  try {
    const { data } = await client.post(
      config.endpoints.saveContactRepMethod,
      contactRepMethodData,
    );
    return data;
  } catch (error) {
    console.log('error saveContactRepMethod', error);
  }
};
